module.exports = __webpack_public_path__ + "img/iconePedidosSeparacao.76d7145c.png";